module.exports = __webpack_public_path__ + "img/thomas-remes.57161894.jpg";